var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAuditLogsIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 16,
  fill: "none",
  viewBox: "0 0 15 16",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 1.2,
  d: "M10.292 3.875h1.466c.77 0 1.155 0 1.45.15.258.132.469.342.6.6.15.295.15.68.15 1.45v6.967a1.833 1.833 0 0 1-3.667 0V4.058c0-1.026 0-1.54-.2-1.932a1.83 1.83 0 0 0-.8-.801c-.393-.2-.906-.2-1.933-.2h-3.3c-1.026 0-1.54 0-1.932.2a1.83 1.83 0 0 0-.801.801c-.2.392-.2.906-.2 1.932v7.884c0 1.026 0 1.54.2 1.932.176.345.456.625.801.801.392.2.906.2 1.932.2h8.067"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 1.2,
  d: "M7.083 2.958h-2.75c-.427 0-.64 0-.81.07a.92.92 0 0 0-.495.496c-.07.169-.07.382-.07.81 0 .426 0 .64.07.808a.92.92 0 0 0 .496.497c.168.07.382.07.809.07h2.75c.427 0 .64 0 .81-.07a.92.92 0 0 0 .495-.497c.07-.168.07-.382.07-.809s0-.64-.07-.809a.92.92 0 0 0-.496-.496c-.168-.07-.382-.07-.809-.07Z"
})));
export { SvgAuditLogsIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/auditLogsIcon.svg";